// extracted by mini-css-extract-plugin
module.exports = {"outlineSystem":"OutlineSystem_outlineSystem__K00oU","outlineSystem__text":"OutlineSystem_outlineSystem__text__yKUVJ"};